import React from "react";
import "./jobstable.css";
import { formatNumber } from "../../../Utils/Utils";
import { useSelector } from "react-redux";

function getGroupName(filterList = {}, groupName) {
  if (!groupName) return null;

  const combinedList = [
    ...(filterList.goods || []),
    ...(filterList.services || []),
    ...(filterList.project || []),
  ];

  const match = combinedList.find(
    (item) => item?.purchasinggroup_name?.trim?.() === groupName.trim()
  );

  return match?.meaning?.trim?.() || null;
}

const JobExpandedTable = ({ data }) => {
  const filterList = useSelector(
    (state) => state?.VendorJobsReducer?.filterList
  );

  return (
    data && (
      <div className="jobs-expanded-table-div">
        <table className="jobs-expanded-table">
          <thead>
            <tr>
              <th>Purchase Requisition</th>
              <th>Description</th>
              <th>Purchase Group</th>
              <th>Item</th>
              <th>Quantity</th>
              <th>Unit</th>
              <th>
                <p style={{ visibility: "hidden" }}>Locationssss</p>
              </th>
              <th>
                <p style={{ visibility: "hidden" }}>Locationssss</p>
              </th>
              <th>
                <p style={{ visibility: "hidden" }}>Locationssss</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((row, index) => (
                <tr key={index}>
                  <td>{row?.PrSapDetail?.PR_ID}</td>
                  <td
                    style={{
                      maxWidth: "120px",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {row?.PrSapDetail?.PR_description_Short}
                  </td>
                  <td
                    style={{
                      maxWidth: "23px",
                    }}
                  >
                    {getGroupName(filterList, row?.PrSapDetail?.PR_Group)}
                  </td>
                  <td>{index + 1}</td>
                  <td>{formatNumber(row?.PrSapDetail?.PR_QTY)}</td>
                  <td>{row?.PrSapDetail?.PR_Unit}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    )
  );
};

export default JobExpandedTable;
